import React from 'react';
import bem from '../../_utils/bem';

var Link = function Link(_ref) {
  var children = _ref.children,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? 'link' : _ref$block,
      element = _ref.element,
      modifiers = _ref.modifiers,
      url = _ref.url,
      target = _ref.target,
      title = _ref.title;
  return /*#__PURE__*/React.createElement("a", {
    href: url,
    target: target,
    title: title,
    className: bem(block, element, modifiers)
  }, children);
};

export default Link;